import state from '@/store/state.js'

// 过滤器
import Vue from "vue"

//部门类型
Vue.filter('DeptFilter', function(val) {
	var test = ""
	if(val != null || val != undefined) {
		state.DEPRTMENTTYPEOPT.forEach(function(items) {
			if(items.value == val) {
				test = items.label
			}
		})
	};
	return test
})
//格式化查验状态
Vue.filter('formatInvoiceStatus', function(value) {
	if(!value) {
		return value = ""
	} else {
		let msg = ""
		switch(value) {
			case "01":
				msg = "查验正常";
				break;
			case "02":
				msg = "发票已作废";
				break;
			case "03":
				msg = "发票已全额红冲";
				break;
			case "04":
				msg = "发票已部分红冲";
				break;

		}
		return msg;
	}
});
Vue.filter('fileterInvoiceDate',function(date){
	var test = "";
	if(date != null || date != undefined) {
		if(date.length > 8){
			test = date.substr(0, 8)
		}else {
			test = date
		}
	}
	return test
})
//公司过滤器
Vue.filter('CompanyFilter', function(val) {
	var test = ""
	if(val != null || val != undefined) {
		state.CompanyOPT.forEach(function(items) {
			if(items.SiteCode == val) {
				test = items.SiteName
			}
		})
	};
	return test
})

//部门类型
Vue.filter('WithholdChange', function(val) {
	var test = ""
	if(val != null || val != undefined) {
		state.withholdFormType.forEach(function(items) {
			if(items.value == val) {
				test = items.label
			}
		})
	};
	return test
})

//格式化空值//
Vue.filter('dataText', function(val) {
	if(!val) {
		return '-'
	} else {
		return val
	}
})

Vue.filter('TaxRateFormat', function(val) {
	if(!val) {
		return '0' + '%';
	} else {
		return val.toFixed(2) + '%'
	}
})

Vue.filter('Percent', function(val) {
	if(!val) {
		return '0' + '%';
	} else {
		return(val * 100).toFixed(2) + '%'
	}
})


//格式化票据类型名称
Vue.filter('formatTypeName', function(value) {
	if(!value) {
		return value = ''
	} else {
		return value.replace("发票 - ", "-");
	}
});
//金额格式化//
Vue.filter('MoneyFormat', function(val) {
	if(val) {
		val = val.toString().replace(/\$|\,/g, '');
		if(isNaN(val)) {
			val = "0";
		};
		let sign = (val == (val = Math.abs(val)));
		val = Math.floor(val * 100 + 0.50000000001);
		let cents = val % 100;
		val = Math.floor(val / 100).toString();
		if(cents < 10) {
			cents = "0" + cents
		};
		for(var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
			val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
		};
		return(((sign) ? '' : '-') + val + '.' + cents);
	} else if(val == 0 || val == null) {
		return '0.00'
	}
});

//格式化月份
Vue.filter('formatYear', function(value) {
	if(!value) {
		return value = ''
	} else {
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy');
	}
});

//格式化月份
Vue.filter('formatMonth', function(value) {
	if(!value) {
		return value = ''
	} else {
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy-MM');
	}
});

//格式化 日期
Vue.filter('fmtDate', function(value) {
	if(!value) {
		return value = ''
	} else {
		value = value.replace('年', '/').replace('月', '/').replace('日', '')
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy年MM月dd日');
	}
});

//格式化 日期
Vue.filter('formatDate', function(value) {
	if(!value) {
		return value = '';
	} else if(new Date(value.replace(/-/g, "/")) == 'Invalid Date') {
		return value
	} else {
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy-MM-dd');
	}
});
//格式化 日期
Vue.filter('formatHour', function(value) {
	if(!value) {
		return value = ''
	} else {
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy-MM-dd hh:mm');
	}
});

//格式化 日期
Vue.filter('fmtDate', function(value) {
	if(!value) {
		return value = ''
	} else {
		value = value.replace('年', '/').replace('月', '/').replace('日', '')
		let newDate = value.replace(/-/g, "/");
		let date = new Date(newDate);
		return formatDate(date, 'yyyy年MM月dd日');
	}
});

//定义formatDate
export function formatDate(date, fmt) { 
	if(/(y+)/.test(fmt)) {     
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));   
	}  
	let o = {     
		'M+': date.getMonth() + 1,
		  'd+': date.getDate(),
		   'h+': date.getHours(),
		  'm+': date.getMinutes(),
		    's+': date.getSeconds()  
	}  
	for(let k in o) {    
		let str = o[k] + '';  
		if(new RegExp(`(${k})`).test(fmt)) {  
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));  
		}  
	} 
	return fmt; 
}; 
export function numAdd(num1, num2) {
	var sq1, sq2, m;
	try {
		sq1 = num1.toString().split(".")[1].length;
	} catch(e) {
		sq1 = 0;
	}
	try {
		sq2 = num2.toString().split(".")[1].length;
	} catch(e) {
		sq2 = 0;
	}
	m = Math.pow(10, Math.max(sq1, sq2));
	return(num1 * m + num2 * m) / m;
}

function padLeftZero(str) { 
	return('00' + str).substr(str.length);
}  

Vue.filter('filterStatus',
	function(value) {
		switch(value.TurnOverCashier) {
			case 0:
				switch(value.IsDraft) {
					case true:
						switch(value.IsAutomatic) {
							case true:
								return '待补票'
								break;
						}
					default:
						return '草稿'
						break;
					case false:
						switch(value.Status) {
							case 1:
								return 'MOA审批中'
								break;
							case 100:
								return '已拒绝'
								break;
							case 10:
								switch(value.IsAutomatic) {
									case true:
										switch(value.PaymentTime != null && value.PaymentTime != '') {
											case true:
												return '完成补票'
												break;
											case false:
												return '待出纳确认'
												break;
										}
										break;
									default:
										return '待报销'
										break;
								}
							default:
								return
								break;
						}
						break;
				}
				break;
			case 1:
				switch(value.Status) {
					case 10:
						switch(value.OnlineBankStatus) {
							case 0:
								return '待报销'
								break;
							case 1:
							case 2:
								return '待审核中'
								break;
							case 3:
								return '已复核'
								break;
							case 5:
								return '支付成功'
								break;
							case -1:
								return '支付失败'
								break;
							default:
								return
								break;
						}
					case 100:
						return '已拒绝'
						break;
				}
				break;
		}
	});

Vue.filter('filterWStatus',
	function(value) {
		switch(value.IsDraft) {
			case true:
				return '草稿'
				break;
			case false:
				switch(value.Status) {
					case 1:
						return 'MOA审批中'
						break;
					case 100:
						return '已拒绝'
						break;
					case 10:
						return '已完成'
						break;
					default:
						return
						break;
				}
				break;
		}
	});

Vue.filter('filterCPStatus',
	function(value) {
		switch(value.Status) {
			case 10:
				switch(value.OnlineBankStatus) {
					case 0:
						return '待报销'
						break;
					case 1:
					case 2:
						return '待审核中'
						break;
					case 3:
						return '已复核'
						break;
					case 5:
						return '支付成功'
						break;
					case -1:
						return '支付失败'
						break;
					default:
						return
						break;
				}
			case 100:
				return '已拒绝'
				break;
		}
	});


// WEBPACK FOOTER //
// ./src/util/filter.js